module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "bodytext-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("Regional map illustrates Meridian’s favorable")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("position between major cities of the South as well")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("as two major river traffic routes. "), _c('em', [_vm._v("J. Parker Lamb")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/xii.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18241b3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword2.vue
// module id = 84
// module chunks = 0